// extracted by mini-css-extract-plugin
export default {"discountBanner":"src-components-Navigation-DiscountBanner__discountBanner","cta":"src-components-Navigation-DiscountBanner__cta"};